export const RootsLine = ({ className = "w-full h-10 text-leaf/40" }) => (
  <svg className={className} viewBox="0 0 400 40" fill="none" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0 8 Q 60 14, 120 8 T 240 8 T 400 8" stroke="currentColor" strokeWidth="1.5" />
    <path d="M70 10 Q 78 26, 96 34 M78 18 Q 70 28, 60 32" stroke="currentColor" strokeWidth="1.2" />
    <path d="M200 9 Q 214 24, 236 30 M212 18 Q 206 30, 194 36" stroke="currentColor" strokeWidth="1.2" />
    <path d="M320 8 Q 332 22, 352 28 M334 16 Q 326 26, 316 30" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

export const RootsMark = ({ className = "w-6 h-6 text-leaf" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <path d="M12 2v9M12 5c-2-2-4-2-5.5-1M12 6c2-2.2 4.2-2.4 5.8-1.2" />
    <path d="M12 11v4M12 13c-3 0-5.5 1.6-7 4.5M12 13c3 0 5.5 1.6 7 4.5M12 15c-1 2.5-2.6 4.5-4.5 6M12 15c1 2.5 2.6 4.5 4.5 6" />
  </svg>
);

export const RootsCorner = ({ className = "absolute -bottom-6 -right-6 w-56 h-56 text-sun/20 pointer-events-none" }) => (
  <svg className={className} viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
    <path d="M200 20 C 150 30, 120 60, 110 110 C 100 150, 70 175, 20 190" />
    <path d="M130 70 C 100 75, 80 60, 60 40 M118 100 C 150 120, 165 150, 170 195 M105 130 C 80 120, 55 125, 30 140 M90 160 C 95 175, 110 185, 130 198" />
  </svg>
);
